
const StepFormLayout = ({ children, title, description }) => {
    return (
        <section>
            <h1 className="block text-sm sm:text-lg font-medium text-stone-700 dark:text-white">
                { title }
            </h1>
            <p className="mb-3 block font-normal text-xs text-stone-400">
                { description }
            </p>
            { children }
        </section>
    );
};

export default StepFormLayout;

